import { Injectable } from '@angular/core';

import { readCookie, writeCookie } from './first-party-cookie';

const LUMIR_VID_COOKIE_NAME = 'lumir_vid';
const LUMIR_VID_STORAGE_KEY = 'lumir_vid';
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365 * 2;
const COOKIE_DOMAIN = '.lumir.photo';

function writeVidCookie(value: string): void {
  writeCookie(LUMIR_VID_COOKIE_NAME, value, { maxAgeSeconds: COOKIE_MAX_AGE_SECONDS, domain: COOKIE_DOMAIN });
}

function readStorage(key: string): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

function writeStorage(key: string, value: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // ignore quota / disabled storage
  }
}

function readUrlParam(name: string): string | null {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  return params.get(name);
}

@Injectable({ providedIn: 'root' })
export class LumirVidService {
  resolve(): string | null {
    const fromUrl = readUrlParam('lvid');
    if (fromUrl) {
      this.persist(fromUrl);
      return fromUrl;
    }

    const fromCookie = readCookie(LUMIR_VID_COOKIE_NAME);
    if (fromCookie) {
      writeStorage(LUMIR_VID_STORAGE_KEY, fromCookie);
      return fromCookie;
    }

    const fromStorage = readStorage(LUMIR_VID_STORAGE_KEY);
    if (fromStorage) {
      writeVidCookie(fromStorage);
      return fromStorage;
    }

    return null;
  }

  private persist(value: string): void {
    writeVidCookie(value);
    writeStorage(LUMIR_VID_STORAGE_KEY, value);
  }
}
